import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useContextProvider, Slot } from "@builder.io/qwik";
import SelectContextId, { groupContextId } from "./select-context.qwik.mjs";
const HSelectGroup = component$((props) => {
  const context = useContext(SelectContextId);
  const groupLabelId = `${context.localId}-group-label`;
  const groupContext = {
    groupLabelId
  };
  useContextProvider(groupContextId, groupContext);
  return /* @__PURE__ */ jsx("div", {
    "aria-labelledby": groupLabelId,
    role: "group",
    ...props,
    ref: context.groupRef,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HSelectGroup
};
